module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3r2r6r9n-ae59cf5db90a8434f537b2e7bc393558.svg";